'use client'

import type { Event } from '@hedepy/common/schemas/modules/event/event'
import Cookies from 'js-cookie'
import { useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

import getGa4PriceInEur from './getGa4PriceInEur'

export const SALESDOUBLER_COOKIE_NAME = 'sd_user'

export const sendPurchaseSalesDoubler = async (event: Event) => {
  if (process.env.NEXT_PUBLIC_ENV !== 'test') {
    const saleAmount = getGa4PriceInEur(event.price, process.env.NEXT_PUBLIC_CURRENCY)

    const clickId = Cookies.get(SALESDOUBLER_COOKIE_NAME)

    if (clickId) {
      const url = `https://rdr.fmcgsd.net/in/postback/6372/${clickId}?trans_id=${event.id}&sale_amount=${saleAmount}&token=bmF6YXJpaS5yZW1iZXppQGhlZGVweS5jb20udWE`
      try {
        await fetch(url)
        Cookies.set(SALESDOUBLER_COOKIE_NAME, '')
      } catch {
        //fail silently
      }
    }
  }
}

const SalesDoubler = () => {
  const searchParams = useSearchParams()

  useEffect(() => {
    saveSalesdoublerCookie()
  }, [])

  const saveSalesdoublerCookie = () => {
    const utm_source = searchParams.get('utm_source')
    const click_id = searchParams.get('aff_sub')
    if (utm_source === 'salesdoubler') {
      Cookies.set(SALESDOUBLER_COOKIE_NAME, click_id, { expires: 30 })
    } else if (utm_source) {
      Cookies.set(SALESDOUBLER_COOKIE_NAME, '')
    }
  }

  return null
}
export default SalesDoubler
